import { Filter16Regular, Search16Regular } from '@/components/Icon'
import styles from './HomeNavPane.module.scss'

export default function HomeNavRecentHeaderActions({ onSearch, onFilter }) {
  return (
    <div className={styles.sectionActions}>
      <button type="button" className={styles.sectionAction} aria-label="Search threads" onClick={onSearch}>
        <Search16Regular aria-hidden />
      </button>
      <button type="button" className={styles.sectionAction} aria-label="Filter threads" onClick={onFilter}>
        <Filter16Regular aria-hidden />
      </button>
    </div>
  )
}
